if(!customElements.get('show-more')) {
  class ShowMore extends HTMLElement {
    constructor() {
      super();

      this.elToggle = this.querySelector('[data-show-more]');
      this.elToggle.addEventListener('click', this.showMore.bind(this));
    }

    showMore() {
      this.classList.add('visible');
      this.elToggle.style.display = 'none';
    }
  }

  customElements.define('show-more', ShowMore);
}